<template>
	<footer id="site-footer" class="in-module" role="contentinfo" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
    <a href="#app" class="pagetop">▲ ページの先頭へ</a>
    <div class="max">
      <div class="company">
        <figure><img src="/images/common/logo.webp" alt="rokuza"></figure>
        <dl>
          <dt>キッズ・パワー株式会社</dt>
          <dd>〒276-0043 千葉県八千代市萱田1147-1<br>TEL：047-406-5930 / FAX：047-406-5931</dd>
        </dl>
      </div>
      <nav>
        <dl>
          <dt>会社情報</dt>
          <dd>
            <ul>
              <li itemprop="name"><a itemprop="url" href="/">トップページ</a></li>
              <li itemprop="name"><a itemprop="url" href="/">企業情報</a></li>
              <li itemprop="name"><a itemprop="url" href="/">事業所情報</a></li>
              <li itemprop="name"><a itemprop="url" href="/">事業所を探す</a></li>
              <li itemprop="name"><a itemprop="url" href="/">採用情報</a></li>
              <li itemprop="name"><a itemprop="url" href="/">お知らせ</a></li>
              <li itemprop="name"><a itemprop="url" href="/">お問い合わせ</a></li>
            </ul>
          </dd>
        </dl>
        <dl>
          <dt class="orange">児童発達支援 / 放課後等デイサービス</dt>
          <dd>
            <ul>
              <li itemprop="name"><a itemprop="url" href="/">トップページ</a></li>
              <li itemprop="name"><a itemprop="url" href="/">教室紹介</a></li>
              <li itemprop="name"><a itemprop="url" href="/">ご利用方法</a></li>
              <li itemprop="name"><a itemprop="url" href="/">指導員紹介</a></li>
              <li itemprop="name"><a itemprop="url" href="/">よくあるご質問</a></li>
              <li itemprop="name"><a itemprop="url" href="/">お子様の効果例</a></li>
              <li itemprop="name"><a itemprop="url" href="/">一日のスケジュール</a></li>
              <li itemprop="name"><a itemprop="url" href="/">アクセス</a></li>
              <li itemprop="name"><a itemprop="url" href="/">ブログ</a></li>
            </ul>
          </dd>
        </dl>
        <dl>
          <dt class="blue">就労継続支援事業</dt>
          <dd>
            <ul>
              <li itemprop="name"><a itemprop="url" href="/">トップページ</a></li>
              <li itemprop="name"><a itemprop="url" href="/">事業所紹介</a></li>
              <li itemprop="name"><a itemprop="url" href="/">ご利用方法</a></li>
              <li itemprop="name"><a itemprop="url" href="/">支援員紹介</a></li>
              <li itemprop="name"><a itemprop="url" href="/">よくあるご質問</a></li>
              <li itemprop="name"><a itemprop="url" href="/">アクセス</a></li>
            </ul>
          </dd>
        </dl> 
      </nav>
    </div>
    <small class="copy">Copyright &copy; {{ currentYear }} Kidspower All rights reserved.</small>
	</footer>
</template>

<style lang="scss" scoped>
footer{
  background: module.tone(module.$gray, -.5);
  color: module.$normal;
  a{
    color: module.$normal;
  }
  .pagetop{
    background: module.tone(module.$gray, -.5);
    border-bottom: module.tone(module.$gray, -1.1) 1px solid;
    display: block;
    text-align: center;
    padding: 1rem 0;
  }
  .max{
    display: grid;
    grid-template-columns: auto 1fr;
    gap: module.side();
    padding: 4.8rem module.side();
    @media screen and (max-width: module.$tab){
      grid-template-columns: 1fr;
    }
  }
  .company{
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 2rem;
    @media screen and (max-width: module.$tab){
      justify-self: center;
    }
    @media screen and (max-width: module.$phone){
      grid-template-columns: 4rem 1fr;
    }
    figure{
      width: 8rem;
      img{
        width: 100%;
        object-fit: cover;
      }
    }
    dl{
      line-height: 1.56;
      dt{
        font-size: 1.24rem;
        font-weight: 700;
      }
      dd{
        font-size: .92rem;
        margin: .4rem 0 0;
      }
    }
    .sns{
      padding: .8rem 0 0;
      @include module.flex();
      align-items: center;
      justify-content: flex-start;
      li{
        margin: 0 .64rem 0 0;
        &:last-child{
          margin: 0;
        }
        a{
          width: 2.8rem;
          height: 2.8rem;
          background: module.$white;
          @include module.flex();
          align-items: center;
          justify-content: center;
          border-radius: .4rem;
          position: relative;
          transition: all 320ms module.$ease;
          &:hover{
            background: module.$normal;
            svg{
              fill: module.$white;
            }
          }
          svg{
            width: 1.32rem;
            height: 1.32rem;
            fill: module.$normal;
            position: relative;
            z-index: 2;
            transition: all 320ms module.$ease;
          }
        }
      }
    }
  }
  nav{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.4rem;
    dl{
      dt{
        font-size: .92rem;
        font-weight: 700;
        margin: 0 0 .8rem;
        padding: 0 0 .64rem;
        border-bottom: module.tone(module.$gray, -1.1) 1px solid;
        position: relative;
        &:after{
          content: '';
          width: 3.2rem;
          height: 1px;
          position: absolute;
          left: 0;
          bottom: -1px;
          background: module.$main;
        }
      }
      dd{
        font-size: .8rem;
        ul{
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-column-gap: 1.6rem;
        }
      }
    }
  }
  small{
    display: block;
    text-align: center;
    font-size: .72rem;
    border-top: rgba(module.$white,.04) .1rem solid;
    padding-bottom: calc(var(--reservation-fix-area) + 3.2rem);
  }
}
</style>

<script>
export default {
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	}
}
</script>